import React from 'react';

const host = process.env.NODE_ENV !== 'development' ? '' : 'http://localhost:8080';

const SocialButton = (params) => {
  const {
    provider, children,
  } = params;
  return (
    <a
      className="btn"
      href={`${host}/api/auth/${provider}`}
    >
      {children}
    </a>
  );
};

export default SocialButton;
